const scrollProperties = () => {
  let currentPosition = 0;
  let currentDirection = 'down';
  const headerHeight = document.querySelector('.header').offsetHeight;
  const navHeight = document.querySelector('.main-nav').offsetHeight;
  const totalHeight = headerHeight + navHeight;
  const root = document.documentElement;

  root.dataset.scrollPosition =
    window.scrollY <= totalHeight ? 'top' : 'not-top';

  function setDirection(direction) {
    if (currentDirection !== direction) {
      currentDirection = direction;
      root.dataset.scrollDirection = direction;
    }
  }

  function setPosition(position) {
    // eslint-disable-next-line no-unused-expressions
    root.dataset.scrollPosition !== position &&
      (root.dataset.scrollPosition = position);
  }

  document.addEventListener('scroll', () => {
    if (currentPosition < window.scrollY) {
      setDirection('down');
    }

    if (currentPosition > window.scrollY) {
      setDirection('up');
    }

    if (window.scrollY <= totalHeight) {
      setPosition('top');
    }

    if (window.scrollY > totalHeight) {
      setPosition('not-top');
    }

    currentPosition = window.scrollY;
  });
};

export default scrollProperties;
